import React from 'react'
import AddPackingListMain from '../addPackingList/addPackingListMain'

const EditPackingList = () => {
    return (
        <div>
            <AddPackingListMain editPacking={true} />
        </div>
    )
}

export default EditPackingList   
